export enum AvatarTextVariant {
  FIRST_LAST = 'first_last',
  FIRST_ONLY = 'first_only',
  HSG = 'hsg',
}
